// @ts-ignore
import React, { useEffect, useState, useContext } from "react";
// @ts-ignore
import propTypes from "prop-types";

import Context from "../../ContextProvider";
import Empfehlungen from "./Empfehlungen";

import {
  Select,
  TextField,
  DateField,
  Range,
  CheckboxNormal,
  Checkbox,
} from "./Inputs";
// @ts-ignore
import { ReactSVG } from "react-svg";

function FormQuestion({ question, answerQuestion, value, index }) {
  const { type, label } = question;

  switch (type) {
    case "date":
      return (
        // @ts-ignore
        <DateField
          question={question}
          value={value || ""}
          setValue={(answer) => {
            answerQuestion(label, answer);
          }}
          index={index}
        />
      );
    case "select":
      return (
        <Select
          question={question}
          value={value}
          setValue={(answer) => {
            answerQuestion(label, answer);
          }}
          index={index}
        />
      );
    case "text":
      return (
        <TextField
          question={question}
          value={value || ""}
          setValue={(answer) => {
            answerQuestion(label, answer);
          }}
          index={index}
        />
      );
    case "range":
      return (
        <Range
          question={question}
          value={value}
          setValue={(answer) => {
            answerQuestion(label, answer);
          }}
          index={index}
        />
      );
    case "checkbox-normal":
      return (
        <CheckboxNormal
          question={question}
          value={value}
          setValue={(answer) => {
            answerQuestion(label, answer);
          }}
          index={index}
        />
      );
    case "checkbox":
      return (
        <Checkbox
          question={question}
          value={value}
          setValue={(answer) => {
            answerQuestion(label, answer);
          }}
          index={index}
        />
      );
    default:
      return null;
  }
}

FormQuestion.propTypes = {
  question: propTypes.shape({
    type: propTypes.string,
    label: propTypes.string,
  }).isRequired,
  value: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
    propTypes.bool,
  ]).isRequired,
  index: propTypes.number.isRequired,
  answerQuestion: propTypes.func.isRequired,
  checked: propTypes.bool, // Add the checked property
  onChange: propTypes.func, // Add the onChange property
  disabled: propTypes.bool, // Add the disabled property
  placeholder: propTypes.string, // Add the placeholder property
};

function ScreenTime({ values }) {
  const noKeys = Object.keys(values).map((key) => values[key]);
  const daily = noKeys.reduce((sum, value) => sum + value);
  const yearly = daily * 365;
  return (
    <div className="screenTime">
      <div>
        <h3>Gesamtzeit digitale Medien</h3>
        <div className="screenTimeNumber">{`${daily} Stunden`}</div>
      </div>
      <div>
        <h3>Gesamtzeit digitale Medien (jährlich)</h3>
        <div className="screenTimeNumber">{`${yearly} Stunden`}</div>
      </div>
    </div>
  );
}

ScreenTime.propTypes = {
  values: propTypes.instanceOf(Object).isRequired,
};

function questionsToValues(questions, responses) {
  const values = {};
  questions.forEach(({ label, defaultValue }) => {
    values[label] =
      responses[label] !== undefined ? responses[label] : defaultValue;
  });
  return values;
}

const objectToArray = (object) => {
  if (!object) return [];
  if (Array.isArray(object)) return object;
  return Object.keys(object)
    .sort()
    .map((key) => object[key]);
};

function formatValues(results, section, responseSection) {
  if (results && results.values) return results.values;
  const { questions, key } = section;
  if (key === "empfehlungen") return responseSection;
  return questionsToValues(questions, responseSection);
}

function FormSection({ 
  results = undefined,
  section,
  updateSection,
  onCheckboxChange,
  onTextFieldChange,
  textFieldValue,
  isTextFieldDisabled,
  onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {}, // Default function to prevent errors
}) {
  const { label, questions, key, withoutLabel, mergeSectionStart, mergeSectionEnd } = section;
  const { responses } = useContext<any>(Context);
  const responseSection = responses[key] || {};
  const [values, setValues] = useState(
    formatValues(results, section, responseSection)
  );

  useEffect(() => {
    if (results) return;
    updateSection(key, { label, values });
  }, []);

  // Logging für sonstigesText nur, wenn sich der Wert ändert:
  // useEffect(() => {
  //   if (values["sonstige Beschwerden"] !== undefined) {
  //     console.log("FormSection sonstigesText id", "sonstigesText");
  //     console.log("FormSection sonstigesText label", "sonstige Beschwerden");
  //   }
  // }, [values["sonstige Beschwerden"]]);

  if (key === "empfehlungen") {
    return (
      // @ts-ignore
      <Empfehlungen
        savedArtikel={objectToArray(values)}
        updateSavedArtikel={(artikel) => {
          updateSection(key, { label, values: artikel });
        }}
      />
    );
  }

  const { type } = questions[0];

  const answerQuestion = (questionLabel, answer) => {
    values[questionLabel] = answer;
    setValues({ ...values });
    updateSection(key, { label, values });
  };

  const assembleHeader = () => {
    if (!Array.isArray(label)) return <h2>{label}</h2>;

    return (
      <h2>
        {label[0]}
        {label.slice(1).map((piece) => (
          <React.Fragment key={piece}>
            <br />
            {piece}
          </React.Fragment>
        ))}
      </h2>
    );
  };
  const sectionHeader = !withoutLabel ? assembleHeader() : null;
  return (
    // Wenn mergeSectionStart, dann füge zur <section></section> css Klassen hinzu
    <section className={`${mergeSectionStart ? "mb-0 pb-0" : ""} ${mergeSectionEnd ? "mt-0" : ""}`}>
      {sectionHeader}
      <form className={`form-${type}`}>
        {questions.map((question, index) => {
          // Leeres Feld für "empty"
          if (question.label === "empty") {
            // console.log("FormSection empty id", question.idName);
            // console.log("FormSection empty label", question.label);
            return <div key={question.idName || question.label || index} className="checkbox empty" />;
          }
          if (question.type === "checkbox" && question.idName === "sonstigesTextCheck") {
            // Checkbox für "sonstiges"
            return (
              <label
                htmlFor="sonstigesTextCheck"
                className={question.readOnly ? 'checkbox disabled' : 'checkbox'}
                key={question.idName || question.label || index}
              >
                <input
                  id={question.idName}
                  type="checkbox"
                  checked={values[question.label] || false} // Werte aus `values` verwenden
                  onChange={(e) => {
                    answerQuestion(question.label, e.target.checked); // Werte in `values` speichern
                    onCheckboxChange(question.idName, e.target.checked);
                  }}
                />
                <div>
                  <ReactSVG src={`/SVG/${question.image}`} />
                  {question.label}
                </div>
              </label>
            );
          }

          if (question.type === "text" && question.idName === "sonstigesText") {
            // console.log("FormSection sonstigesText id", question.idName);
            // console.log("FormSection sonstigesText label", question.label);
            // Textfeld für "sonstiges"
            return (
              <div key={question.idName} className={`test inputWrapper text ${question.className || ""}`}>
                {question.label && !question.withoutLabel && (
                  <>
                    <label htmlFor={question.idName}>{question.label}</label>
                    <br />
                  </>
                )}
                <div key={question.idName} className="textWrapper">
                  <input
                    type="text"
                    id={question.idName}
                    value={values[question.label] || ""} // Werte aus `values` verwenden
                    onChange={(e) => {
                      answerQuestion(question.label, e.target.value); // Werte in `values` speichern
                      onTextFieldChange(question.idName, e.target.value);
                    }}
                    onKeyDown={onKeyDown}
                    disabled={isTextFieldDisabled}
                    placeholder={isTextFieldDisabled ? "" : "Bitte geben Sie Ihre Beschwerden ein"}
                  />
                </div>
              </div>
            );
          }

          // Standardfrage
          return (
            <FormQuestion
              //@ts-ignore
              key={question.idName || question.id || question.label || index}
              index={index}
              question={question}
              answerQuestion={answerQuestion}
              value={values[question.id ?? question.label]}
            />
          );
        })}
      </form>
      {key === "screenTime" && <ScreenTime values={values} />}
    </section>
  );
}

FormSection.propTypes = {
  //@ts-ignore
  section: propTypes.shape([]).isRequired,
  updateSection: propTypes.func.isRequired,
  results: propTypes.instanceOf(Object),
  onCheckboxChange: propTypes.func.isRequired,
  onTextFieldChange: propTypes.func.isRequired,
  textFieldValue: propTypes.string.isRequired,
  isTextFieldDisabled: propTypes.bool.isRequired,
  onKeyDown: propTypes.func, // Hinzufügen der onKeyDown-Eigenschaft
};

export default FormSection;
